/* Utilities */
window.Cookies = require('js-cookie');


/* Polyfills */
Number.isInteger = (typeof Number.isInteger !== 'undefined') ? Number.isInteger : require('is-integer');


/* Helpers */
import {BrowserEngineDetect} from './helpers/browser-engine-detect';
BrowserEngineDetect();

require('./helpers/query-string-parameters.js');
require('./helpers/breakpoints.js');
require('./helpers/force-checked.js');
require('./helpers/gravityforms-fields.js');


/* Components */
require('./components/iframe-break.js');
// const MutationObserver = new (require('./components/mutation-observer.js'));
const SiteHeader = new (require('./components/site-header.js'));
require('./components/tooltips.js');
require('./components/iframe-providersearch.js');
require('./components/link-confirmation.js');
require('./components/to-top.js');
require('./components/toc.js');
require('./components/widget-labels.js');
require('./components/zip-code-search-form.js');
require('./components/zc2market-router-form.js');
require('./components/prescription-drug-search-router-form.js');
require('./components/lumeris-combobox.js');
require('./components/lumeris-documents/lumeris-documents.js');
require('./components/equal-dimensions.js');
require('./components/unlazyload.js');
require('./components/gravity-forms.js');

/* Templates */
// require('./templates/header.js');